import { createContext } from "react";
import type {
  TransactionRequest,
  TransactionResponse,
  WalletAccount,
  WalletAdapterStatus,
} from "../utils/types";

export interface WalletContextType {
  status: WalletAdapterStatus;
  selectedAccount: WalletAccount | null;
  connect: () => Promise<void>;
  disconnect: () => Promise<void>;
  sendTransaction: (tx: TransactionRequest) => Promise<TransactionResponse>;
  switchChain?: (supportedChains?: string[]) => Promise<boolean>; // Optional supportedChains parameter
  closeModal?: () => void; // Close any open wallet modals
}

export const WalletContext = createContext<WalletContextType | undefined>(undefined);
